import {AbstractModel} from './abstract-model';
import {Goal} from './goal';
import {GoalType} from './goal-type';
import {Currency} from './currency';

export class CustomPayout extends AbstractModel {
  id: number | null = null;
  payoutAmount: number | null = null;
  payoutPercent: number | null = null;
  position: number = 0;
  goal: Goal | null = null;
  goalType: GoalType | null = null;
  currency: Currency | null = null;
  offerIds: number[] = [];
  subIds: string[] = [];

  override deserialize(input: any): this {
    super.deserialize(input);

    if (input.goal) {
      this.goal = new Goal().deserialize(input.goal);
    }

    if (input.goalType) {
      this.goalType = new GoalType().deserialize(input.goalType);
    }

    if (input.currency) {
      this.currency = new Currency().deserialize(input.currency);
    }

    return this;
  }
}
